import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './index.scss';
import StepsIndicator from './Components/StepsIndicator'
import ResumeBuilderHeader from './Components/BuilderHeader';
import PersonalDetailsStep from './Components/PersonalDetailsStep';
import ContactInfoStep from './Components/ContactInfoStep';
import EmploymentHistoryStep from './Components/EmploymentHistoryStep';
import SkillsStep from './Components/SkillsStep';
import EducationStep from './Components/EducationStep';
import LanguageStep from './Components/LanguageStep';
import SummaryStep from './Components/SummaryStep'
import { getRequest, postRequest } from '../../services/requestService';
import { evaluateProfile } from './service';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import ImproveStep from './Components/ImproveStep';
import _ from 'lodash'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Button } from 'antd';
import { FaArrowLeft } from '@react-icons/all-files/fa/FaArrowLeft';
import SignupModal from './Components/SignupModal';
import { getCookie, setCookie, scrollToTop } from '../../services/clientService';
import { GOOGLE_ADS_ACCOUNT_ID, GOOGLE_ADS_CONVERSION_SIGNUP, reportEvent, reportGoogleConversion } from '../../services/analyticsService';
import PurchaseModal from './Components/PurchaseModal';
import DesignStep from './Components/DesignStep';
import { DEFAULT_PARAMS } from './constants';
import ResumeCanvasPreview from '../../components/pdf/ResumeCanvasPreview';
const steps = ['personal', 'contact', 'employment', 'skills', 'education', 'language', 'summary']
const ResumeBuilder = () => {
    const { resumeId, step } = useParams();
    const location = useLocation();
    const [didCompleteWizard, setDidCompleteWizard] = useState(false)
    const [purchaseModalOpen, setPurchaseModalOpen] = useState(false)
    const [formLoading, setFormLoading] = useState(false)
    const [resume, setResume] = useState()
    const [signupModalOpen, setSignupModalOpen] = useState(false)
    const [visitedSteps, setVisitedSteps] = useState([0])
    const [params, setParams] = useState(DEFAULT_PARAMS)
    const dispatch = useDispatch()
    const profileReport = evaluateProfile(params)

    // Get current step from URL parameter
    const getCurrentStepFromUrl = () => {
        if (!step) return 0;
        const stepIndex = steps.indexOf(step);
        return stepIndex >= 0 ? stepIndex : 0;
    }

    const currentStep = getCurrentStepFromUrl();

    const getMode = () => {
        if (location.pathname.includes('design')) return 'design'
        if (location.pathname.includes('improve')) return 'improve'

        return 'form'
    }
    const mode = getMode()

    const onContinueClick = async () => {
        setFormLoading(true)
        console.log('Continue clicked, current step:', currentStep)

        if (currentStep + 1 < 7) {
            reportEvent('resume_builder', `${steps[currentStep]}_click`)
            console.log('Making API call to update resume...')
            const res = await postRequest(`resume/update-guest`, { ...params, resumeId })
            console.log('API call completed, navigating to next step')
            setResume(res.data.resume)

            // Navigate to next step URL
            const nextStep = steps[currentStep + 1];
            dispatch(push(`/resume-builder/${resumeId}/${nextStep}`))
            setVisitedSteps(_.uniq([...visitedSteps, currentStep + 1]))
        }
        else {
            console.log('Making final API call...')
            const res = await postRequest(`resume/update-guest`, { ...params, resumeId })
            console.log('Final API call completed, navigating to design')
            setResume(res.data.resume)
            reportEvent('resume_builder', 'form_submit', { currentStep: steps[currentStep] })
            try {
                window.lintrk('track', { conversion_id: 22735249 });


            }
            catch (e) {

            }
            reportGoogleConversion({
                kind: 'signup',
                sendTo: `${GOOGLE_ADS_ACCOUNT_ID}/${GOOGLE_ADS_CONVERSION_SIGNUP}`,
                transactionId: resumeId,
                value: "1.0",
                'currency': 'USD',
            })
            setDidCompleteWizard(true)
            dispatch(push(`/resume-builder/${resumeId}/design`))
        }
        scrollToTop()
        setFormLoading(false)
    }
    const onBackClick = () => {
        if (currentStep > 0) {
            const prevStep = steps[currentStep - 1];
            dispatch(push(`/resume-builder/${resumeId}/${prevStep}`))
        }
    }

    const onStepClick = (stepId) => {
        const stepName = steps[stepId];
        dispatch(push(`/resume-builder/${resumeId}/${stepName}`))
    }

    const onChange = async (key, value) => {
        if (mode === 'design') {
            const updatedParams = {
                ...params,
                design: {
                    ...params.design,
                    [key]: value
                }
            }
            setParams(updatedParams)
            const res = await postRequest(`resume/update-guest`, { ...updatedParams, resumeId })
            setResume(res.data.resume)
        }
        else {
            setParams({
                ...params,
                [key]: value
            })
        }

    }

    useEffect(() => {
        if (!getCookie('resume_id')) {
            setCookie('resume_id', resumeId)
        }
        reportEvent('resume_builder', 'wizard_load')
        // Check if the previous URL is /resume-builder/create
        // If so - remove it from the history so the user will not be able to hit back
        const previousUrl = location.state?.from;

        if (previousUrl && previousUrl.includes('/resume-builder/create')) {
            console.log('Removing create page from history');

            // Add event listener to intercept back button clicks
            const handlePopState = (e) => {
                // If user tries to go back, prevent it and stay on current page
                window.history.pushState(null, '', window.location.href);
            };

            // Push current state to prevent going back
            window.history.pushState(null, '', window.location.href);
            window.addEventListener('popstate', handlePopState);

            // Clean up event listener
            return () => {
                window.removeEventListener('popstate', handlePopState);
            };
        }
    }, [location])

    useEffect(() => {
        if (resumeId && !resume) {
            getRequest(`resume/${resumeId}`).then(res => {
                const updatedResume = {
                    ...res.data.resume,
                    dateOfBirth: res.data.resume.dateOfBirth ? dayjs(res.data.resume.dateOfBirth) : undefined,
                }
                setResume(updatedResume)
                setParams(updatedResume)
            })
        }
    }, [resumeId, resume])

    useEffect(() => {
        if (['design', 'improve'].includes(mode)) {
            setDidCompleteWizard(true)
        }
    }, [mode])

    // Update visited steps when step changes
    useEffect(() => {
        setVisitedSteps(prev => _.uniq([...prev, currentStep]))
    }, [currentStep])

    // Redirect to personal step if no step is specified in URL
    useEffect(() => {
        if (resumeId && !step && mode === 'form') {
            console.log('Redirecting to personal step')
            dispatch(push(`/resume-builder/${resumeId}/personal`))
        }
    }, [resumeId, step, mode, dispatch])

    if (!resume) return null;

    return (
        <div className={`resume-builder-page mode-${mode}`}>
            <ResumeBuilderHeader resume={resume} setPurchaseModalOpen={setPurchaseModalOpen} didCompleteWizard={didCompleteWizard} setSignupModalOpen={setSignupModalOpen} profileReport={profileReport} mode={mode} resumeId={resumeId} />
            <div className="inner-content">
                {mode === 'improve' && <ImproveStep resumeId={resumeId} resume={resume} profileReport={profileReport} />}
                {mode === 'design' && <DesignStep setPurchaseModalOpen={setPurchaseModalOpen} setSignupModalOpen={setSignupModalOpen} resumeId={resumeId} resume={resume} params={params} onChange={onChange} />}
                {mode === 'form' && (
                    <>
                        <StepsIndicator visitedSteps={visitedSteps} didCompleteWizard={didCompleteWizard} onStepClick={onStepClick} currentStep={currentStep} />
                        <div className="forms-and-preview">
                            {currentStep === 0 && <PersonalDetailsStep formLoading={formLoading} params={params} onChange={onChange} onContinueClick={onContinueClick} />}
                            {currentStep === 1 && <ContactInfoStep formLoading={formLoading} params={params} onChange={onChange} onContinueClick={onContinueClick} onBackClick={onBackClick} />}
                            {currentStep === 2 && <EmploymentHistoryStep formLoading={formLoading} params={params} onChange={onChange} onContinueClick={onContinueClick} onBackClick={onBackClick} />}
                            {currentStep === 3 && <SkillsStep formLoading={formLoading} params={params} onChange={onChange} onContinueClick={onContinueClick} onBackClick={onBackClick} />}
                            {currentStep === 4 && <EducationStep formLoading={formLoading} params={params} onChange={onChange} onContinueClick={onContinueClick} onBackClick={onBackClick} />}
                            {currentStep === 5 && <LanguageStep formLoading={formLoading} params={params} onChange={onChange} onContinueClick={onContinueClick} onBackClick={onBackClick} />}
                            {currentStep === 6 && <SummaryStep formLoading={formLoading} params={params} onChange={onChange} onContinueClick={onContinueClick} onBackClick={onBackClick} />}
                            {params?.firstName && (
                                <div className="resume-preview-container">
                                    <ResumeCanvasPreview resume={params} />
                                </div>
                            )}
                        </div>
                    </>
                )}

            </div>
            {["design"].includes(mode) && <div className="floating-footer">
                <Button onClick={() => dispatch(push(`/resume-builder/${resumeId}/personal`))}>
                    <FaArrowLeft />
                    Back</Button>
            </div>}
            <SignupModal setSignupModalOpen={setSignupModalOpen} signupModalOpen={signupModalOpen} />
            <PurchaseModal open purchaseModalOpen={purchaseModalOpen} setPurchaseModalOpen={setPurchaseModalOpen} />
        </div>
    );
};

export default ResumeBuilder; 